import { left, right } from 'fp-ts/Either';
import { httpClientFunction } from 'domain/types';
import ReadWidgetDataClient from 'use-case/widgets/data/read/readWidgetDataClient';
import ReadWidgetDataCriteria from 'use-case/widgets/data/read/readWidgetDataCriteria';
import { asTextBlockWidget, JsonWidgetDataError, JsonWidgetRichTextData } from 'adapter/out/client/widgets/data/mappers/common';

export const asWidgetDataError = (json: JsonWidgetDataError, status: number) => left({ error: new Error(json.message), status });

const readTextBlockDataApiClient = (
    httpClient: httpClientFunction,
    baseUrl: string,
    buildUrl: (criteria: ReadWidgetDataCriteria) => string = () => '/dashboards'
): ReadWidgetDataClient => (criteria: ReadWidgetDataCriteria) => {
    const url = criteria.reportInstanceId
        ? `${baseUrl}/dashboards/reports/${criteria.reportInstanceId}/proxy/api-v3/dashboards/texts/${criteria.widgetId}`
        : `${baseUrl}${buildUrl(criteria)}/texts/${criteria.widgetId}`;

    return httpClient(url, {})
        .then(async (response) =>
            response.ok
                ? response
                      .json()
                      .then((json) => asTextBlockWidget(json as JsonWidgetRichTextData))
                      .then(right)
                      .catch((error: Error) => asWidgetDataError((error as unknown) as JsonWidgetDataError, 500))
                : asWidgetDataError(await response.json(), response.status)
        )
        .catch((error: Error) => asWidgetDataError((error as unknown) as JsonWidgetDataError, 500));
};

export default readTextBlockDataApiClient;
